import {
    validate,
    clean,
    format
} from 'rut.js';

import validator from 'validator'

const validation = {
    email(str) {
        return validator.isEmail(str)
    }
}


export default {
    isNumeric(str) {
        return validator.isNumeric(str,{no_symbols:true} )
    },
    isEmail(str) {
        return validator.isEmail(str)
    },
    isEmpty(str) {
        return validator.isEmpty(str)
    },
    isURL(str) {
        return validator.isURL(str)
    },
    toBoolean(str) {
        return validator.toBoolean(str)
    },
    rut: {
        isValid(str) {
            return validate(str)
        },
        clean(str) {
            return clean(str)
        },
        format(str) {
            return format(str)
        }
    }
}

export {
    validation
}